import { isString } from 'lodash/fp';
import { parseISO } from 'date-fns/fp';
export default function ensureParseISO(dateString) {
  return isString(dateString) ? parseISO(dateString) : dateString;
}